import { Button, Text } from "@kunduz/ui-atoms";
import { calculateExamScoreViaAPI } from "../../../common/service/service";
import { RESET } from "../../../common/utilites/types";
import { useAppContext } from "../../context/context";
import styles from "./resultContainer.module.scss";
import { InputV2 } from "@kunduz/ui";

export default function ResultContainer() {
  const {
    state,
    diplomaScore,
    setDiplomaScore,
    tytExamActive,
    aytExamActive,
    ydtExamActive,
    setError,
    calculateLoading,
    setCalculateLoading,
    examScore,
    setExamScore,
    dispatch,
  } = useAppContext();

  const changeDiplomaScore = (e: any) => {
    if (Number(e.target.value)) {
      setDiplomaScore(e.target.value);
    }
  };

  const clearState = () => {
    dispatch({
      type: RESET,
    });
  };

  const onFocus = (e: any) => {
    if (!Number(e.target.value)) {
      e.target.value = "";
    }
  };

  const calculateScore = () => {
    if (parseFloat(diplomaScore) >= 50 && parseFloat(diplomaScore) <= 100) {
      setCalculateLoading(true);
      const examData = {
        test_type: "YKS",
        scores: [
          {
            ...(tytExamActive && {
              tyt: state.TYT.map((item: any) => ({
                course_test: item.id,
                correct: item.correct,
                wrong: item.wrong,
              })),
            }),
            ...(aytExamActive && {
              ayt: state.AYT.map((item: any) => ({
                course_test: item.id,
                correct: item.correct,
                wrong: item.wrong,
              })),
            }),
            ...(ydtExamActive && {
              ydt: {
                ...state.YDT.map((item: any) => ({
                  course_test: item.id,
                  correct: item.correct,
                  wrong: item.wrong,
                })),
              }[0],
            }),
            diploma_grade: parseFloat(diplomaScore),
          },
        ],
      };

      calculateExamScoreViaAPI(examData)
        .then((result) => {
          setExamScore(result.scores);
          setError(false);
          if (result.error_message) {
            setError(true);
          }
        })
        .catch(() => setError(true))
        .finally(() => setCalculateLoading(false));
    } else {
      alert("Diploma Notu 50 İle 100 Arasında Olmalıdır.");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <span className={styles.headerItem}>SONUÇLAR</span>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.inputGroupContainer}>
          <span className={styles.titleItem}>TÜRÜ</span>
          <span className={styles.titleItem}>HAM PUAN</span>
          <span className={styles.titleItem}>NET PUAN</span>
        </div>
        <div className={styles.inputGroupContainer}>
          <span className={styles.resultItem}>TYT</span>

          <InputV2
            value={examScore?.raws?.tyt || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
          <InputV2
            value={examScore?.placements?.tyt || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
        </div>
        <div className={styles.inputGroupContainer}>
          <span className={styles.resultItem}>SAY</span>
          <InputV2
            value={examScore?.raws?.say || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
          <InputV2
            value={examScore?.placements?.say || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
        </div>
        <div className={styles.inputGroupContainer}>
          <span className={styles.resultItem}>EA</span>
          <InputV2
            value={examScore?.raws?.ea || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
          <InputV2
            value={examScore?.placements?.ea || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
        </div>
        <div className={styles.inputGroupContainer}>
          <span className={styles.resultItem}>SÖZ</span>
          <InputV2
            value={examScore?.raws?.soz || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
          <InputV2
            value={examScore?.placements?.soz || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
        </div>
        <div className={styles.inputGroupContainer}>
          <span className={styles.resultItem}>YBDİL</span>
          <InputV2
            value={examScore?.raws?.ybdil || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
          <InputV2
            value={examScore?.placements?.ybdil || Number(0).toFixed(2)}
            type="number"
            disabled
            placeholder="0"
          />
        </div>
        <div className={styles.inputGroupContainer}>
          <span className={styles.resultItem}>DİPLOMA NOTU</span>
          <InputV2
            onFocus={onFocus}
            value={diplomaScore}
            onChange={changeDiplomaScore}
            type="tel"
            placeholder="0"
          />
        </div>
        <div className={styles.buttonGroupContainer}>
          <Button
            onClick={clearState}
            variant="tertiary"
            color="gray"
            size="md"
          >
            <Text variant="textmd" weight="semibold">
              TEMİZLE
            </Text>
          </Button>

          <Button
            disabled={calculateLoading}
            onClick={calculateScore}
            variant="primary"
            color="blue"
            size="md"
          >
            <Text variant="textmd" weight="semibold">
              HESAPLA
            </Text>
          </Button>
        </div>
      </div>
    </div>
  );
}
